/* eslint-disable jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-autofocus */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Icon from 'components/Icon';

import FilterButton from '../Button';

import styles from './styles.module.scss';

const Search = ({
	name,
	onEnter,
	placeholder,
	defaultTitle,
	theme,
	...props
}) => {
	const inputRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [value, setValue] = useState(props.value);

	useEffect(() => {
		setValue(props.value);
	}, [props.value]);

	useEffect(() => {
		if (inputRef.current) {
			if (isOpen) {
				inputRef.current.focus();
			} else {
				inputRef.current.blur();
			}
		}
	}, [isOpen]);

	const handleChange = useCallback(() => {
		setValue(inputRef.current.value);
	}, []);

	const handleKeyDown = useCallback(
		(event) => {
			if (event.key === 'Escape' || event.key === 'Enter') {
				onEnter(name, value);
				setIsOpen(false);
			}
		},
		[onEnter, value]
	);

	const handleReset = useCallback(() => {
		setValue('');
		onEnter(name, '');

		if (inputRef.current) {
			inputRef.current.focus();
		}
	}, [onEnter]);

	const handleBlur = useCallback(
		(event) => {
			if (
				!event.currentTarget.contains(
					event.relatedTarget || document.activeElement
				)
			) {
				setIsOpen(false);
				onEnter(name, value);
			}
		},
		[onEnter, value]
	);

	const showSearch = useCallback(() => setIsOpen(true), []);

	return (
		<div className={cx(styles.Search, styles[`Search_theme_${theme}`])}>
			<FilterButton
				className={cx(
					styles.Search__Control,
					isOpen && styles.Search__Control_open
				)}
				onClick={showSearch}
				onBlur={handleBlur}
				theme="bright"
				icon="search"
				iconClassName={cx(styles.Search__Icon, styles.Search__Icon_search)}
				title={!isOpen && (value || defaultTitle)}
				titleClassName={styles.Search__ButtonTitle}
			/>
			{isOpen && (
				<div className={styles.Search__Form}>
					<input
						className={styles.Search__Input}
						placeholder={placeholder}
						ref={inputRef}
						value={value}
						onChange={handleChange}
						onKeyDown={handleKeyDown}
						autoFocus
					/>
					{value && (
						<button
							className={styles.Search__Button}
							onClick={handleReset}
							tooltip="Очистить"
							type="button"
							aria-label="Очистить данные"
						>
							<Icon
								icon="close"
								className={cx(styles.Search__Icon, styles.Search__Icon_close)}
							/>
						</button>
					)}
				</div>
			)}
		</div>
	);
};

Search.propTypes = {
	value: PropTypes.string,
	defaultTitle: PropTypes.string,
	name: PropTypes.string,
	onEnter: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	theme: PropTypes.oneOf(['transparent'])
};

Search.defaultProps = {
	name: 'query',
	placeholder: 'Введите поисковый запрос',
	value: '',
	defaultTitle: 'Поиск'
};

export default Search;
